import Vue from 'vue'
import router from './router'

import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import axios from 'axios';

import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import "./assets/fontello/css/ozivu.css";

Chart.plugins.unregister(ChartDataLabels);

Vue.config.productionTip = false

Vue.use(require('vue-moment'));

//  in case we reload
axios.defaults.headers.common['X-Custom-Authorization'] = localStorage.jwt;

axios.interceptors.response.use((response) => {return response},
  function (error) {
    // intercept the global error
    // let originalRequest = error.config
    if (error.response.status === 401) {
      router.push('/login');
    }
    return Promise.reject(error);
  }
);

import App from './App.vue'

new Vue({
  router,
  render: h => h(App),
  data() { return{
    firstName: "(inconnu)",
    // server_base: "http://localhost:80"
    server_base: ""
  }}
}).$mount('#app')
